import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { galleryData } from '../mockData';
import { GalleryImageCard } from '../components/gallery/GalleryImageCard';
import { ImageLightbox } from '../components/gallery/ImageLightbox';
import { Camera } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ASSETS = 'https://customer-assets.emergentagent.com/job_wedding-countdown-pk/artifacts';

const dressCodePhotos = [
  { id: 'dresscode1', url: `${ASSETS}/m6nalpl7_photo_5395373046232717007_y.jpg`, caption: 'Black Tie Elegance for Gentlemen' },
  { id: 'dresscode2', url: `${ASSETS}/pe5wxsb4_photo_5395373046232717008_y.jpg`, caption: 'Formal Attire Examples' },
  { id: 'dresscode3', url: `${ASSETS}/ivspz0f5_photo_5395373046232717009_y.jpg`, caption: 'Colourful Gowns & Tuxedos' },
  { id: 'dresscode4', url: `${ASSETS}/jjhybile_photo_5395373046232717010_y.jpg`, caption: 'Floor-Length Gowns' },
  { id: 'dresscode5', url: `${ASSETS}/n3dspbvx_photo_5395373046232717011_y.jpg`, caption: 'Black Tie Attire Guide' },
  { id: 'dresscode6', url: `${ASSETS}/65rosr4o_1%20option.jpg`, caption: 'Colorful Summer Wedding Attire' },
  { id: 'dresscode7', url: `${ASSETS}/09cky7a9_2%20option.jpg`, caption: 'Elegant Gowns & Tuxedo Styling' },
  { id: 'dresscode8', url: `${ASSETS}/lh0rbelt_photo_5339402780482935490_w.jpg`, caption: 'Wedding Day Attire' },
  { id: 'dresscode9', url: `${ASSETS}/w2s3pi6y_photo_5339402780482935489_w.jpg`, caption: 'European Summer Black Tie' },
  { id: 'dresscode10', url: `${ASSETS}/kb97yanf_photo_5339402780482935488_y.jpg`, caption: 'Colorful Elegant Celebration Wear' },
  { id: 'dresscode11', url: `${ASSETS}/03svc6z9_72d32290-af23-4c17-8a6f-49ce019caeae.jpg`, caption: 'Summer Formal Inspiration' }
];

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const { t } = useLanguage();

  useEffect(() => {
    if (window.location.hash === '#dress-code-inspiration') {
      setTimeout(() => {
        const element = document.getElementById('dress-code-inspiration');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Header Section */}
      <section className="pt-48 pb-16 cream-bg">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center fade-in">
          <Camera className="w-12 h-12 blue-text mx-auto mb-6" />
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold blue-text mb-6">
            {t('gallery.title')}
          </h1>
          <p className="font-sans text-lg md:text-xl blue-text opacity-80">
            {t('gallery.subtitle')}
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 cream-bg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryData.photos.map((photo, index) => (
              <GalleryImageCard key={photo.id} photo={photo} delay={index * 0.1} onClick={setSelectedImage} />
            ))}
          </div>
        </div>
      </section>

      {/* Dress Code Inspiration Section */}
      <section id="dress-code-inspiration" className="py-20 cream-bg border-t-2 border-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-serif text-4xl md:text-5xl font-bold blue-text mb-4">
              {t('gallery.dressCode')}
            </h2>
            <p className="font-sans text-lg blue-text opacity-80">
              {t('gallery.dressCodeSubtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {dressCodePhotos.map((photo, index) => (
              <GalleryImageCard key={photo.id} photo={photo} delay={index * 0.1} onClick={setSelectedImage} />
            ))}
          </div>
        </div>
      </section>

      <ImageLightbox image={selectedImage} onClose={() => setSelectedImage(null)} />

      <Footer />
    </div>
  );
};
